module.exports = __webpack_public_path__ + "img/pepe-reis.7a6570a9.jpg";